<template>
  <sa-page-layout
    :titolo="titolo"
    :pathResource="pathResource"
    :linkback="linkback"
    :data="jsonData"
    :btnAnnullaVisible="true"
    :btnSaveVisible="true"
    :showModalLoading="showModalLoading"
    class="sa-no-space"
  >
    <template slot="table-body">
      <div class="sa-tab-scroll">
        <b-row>
          {{ jsonData }}
          <b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
            <label class="sa-label-data"> Report Master</label>
            <b-form-input
              v-model="reportMasterName"
              :disabled="true"
            ></b-form-input>
          </b-col>
          <b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
            <label class="sa-label-data"> Struttura</label>
            <b-form-input
              v-model="strutturaCodice"
              :disabled="true"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
            <label class="sa-label-data">Sub Report Name</label>
            <b-form-input
              v-model="jsonData.reportName"
              :disabled="true"
            ></b-form-input>
          </b-col>
          <b-col cols="10" xs="10" sm="10" md="2" lg="2" xl="2">
            <label class="sa-label-data">Nome File</label>
            <b-form-select
              v-model="jsonData.nomeFile"
              :options="nomiFileOptions"
              :value="null"
              value-field="value"
              :disabled="true"
              text-field="text"
            >
              <template #first>
                <b-form-select-option :disabled="true" :value="null"
                  >- Seleziona Nome File -</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
          <b-col cols="2" xs="2" sm="2" md="1" lg="1" xl="1">
            <label class="sa-label-data">File</label>
            <b-button
              size="sm"
              v-b-tooltip.hover
              title="Scegli File"
              variant="outline-primary"
              @click="onClickFileIcon()"
            >
              <font-awesome-icon icon="file" />
            </b-button>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label class="sa-label-data">Descrizione</label>
            <b-form-input v-model="jsonData.descrizione"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
            <label class="sa-label-data">Versione</label>
            <b-form-input
              v-model="jsonData.versione"
              :disabled="true"
            ></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
            <label class="sa-label-data">Stato</label>
            <b-form-select
              v-model="jsonData.stato"
              :options="statiReportOptions"
              :disabled="true"
              :value="null"
              value-field="value"
              text-field="text"
            >
              <template #first>
                <b-form-select-option :disabled="true" :value="null"
                  >- Seleziona Stato -</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
        </b-row>
      </div>
    </template>
    <template slot="table-footer">
      <b-modal
        ref="mdlUploadFile"
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        :title="
          isNewElement
            ? 'Carica File Sub Report .jasper'
            : `Carica versione ${jsonData.versione} di ${jsonData.nomeFile} Sub Report`
        "
        centered
      >
        <strong>{{ messageErrorUpdateVersion }}</strong>
        <print-report-import-file-component
          :jsonData="jsonDataReport"
          @update="onUpdateReport"
        ></print-report-import-file-component>
        <template #modal-footer>
          <b-button
            size="sm"
            v-b-tooltip.hover
            title="Annulla e torna alla lista"
            variant="outline-danger"
            @click="onAnnulla()"
          >
            Annulla
            <font-awesome-icon icon="times-circle" />
          </b-button>
          <b-button
            size="sm"
            v-b-tooltip.hover
            title="Carica File Sub Report .jasper"
            variant="outline-info"
            :disabled="!isOKFileUpload"
            @click="onConfermaFile()"
          >
            Conferma File
            <font-awesome-icon icon="plus" />
          </b-button>
        </template>
      </b-modal>

      <b-modal ref="mdlStampaReferto" size="xl" style="height: 100%">
        <b-embed type="iframe" :src="stampaReport" allowfullscreen></b-embed>
      </b-modal>
    </template>
  </sa-page-layout>
</template>
<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PrintReportImportFileComponent from "../../../app/printreport/components/PrintReportImportFileComponent.vue";
export default {
  components: { SaPageLayout, PrintReportImportFileComponent },
  mounted() {
    let me = this;
    me.id = this.$route.params.id;

    me.loadData();

    me.jsonData.stato = "ATTIVO";
    me.jsonData.versione = 1;
    let reportMasterString = sessionStorage.getItem("reportMaster");
    me.reportMaster = JSON.parse(reportMasterString);
    console.log(me.reportMaster);

    me.reportMasterName = me.reportMaster.reportName;
    me.strutturaCodice = me.reportMaster.struttura;

    me.jsonData.idReportMaster = me.reportMaster.reportMaster;
    me.jsonData.codiceStruttura = me.reportMaster.struttura;
    me.linkback = "/printserver/view/" + me.reportMaster.reportMaster;
    me.loadNomiFile();
    me.$refs.mdlUploadFile.show();
  },
  data() {
    return {
      titolo: "Print Server Sub Report Edit ",
      pathResource: "/printserversubreport",
      pathResourceStampa: "/print/createreport",
      stampaReport: null,
      reportMaster: null,
      messageErrorUpdateVersion: "",
      jsonDataReport: {},
      isReportUpdateNotValid: false,
      showModalLoading: false,
      isOKFileUpload: false,
      linkback: null,
      id: "",
      reportMasterName: "Report Master name",
      strutturaCodice: "codice Struttura",
      jsonError: false,
      linkNomiFile: "/printserver/nomifile",
      jsonData: {
        nomeFile: null,
        stato: null,
        reportName: null,
        idReportMaster: "",
      },
      statiReportOptions: [
        { value: "ATTIVO", text: "ATTIVO" },
        { value: "SOSPESO", text: "SOSPESO" },
        { value: "OBSOLETO", text: "OBSOLETO" },
      ],
      nomiFileOptions: [],
    };
  },
  computed: {
    isNewElement() {
      let me = this;
      if (me.id === "-1") {
        return true;
      }
      return false;
    },
  },
  methods: {
    loadData() {
      let me = this;
      me.showModalLoading = true;
      if (me.id === "-1") {
        me.showModalLoading = false;
      } else {
        let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
        axios.get(link + me.id).then((response) => {
          me.jsonData = response.data.data;
          me.jsonData.id = "-1";
          me.jsonData.versione += 1;
          me.showModalLoading = false;
        });
      }
    },
    onAnnulla() {
      let me = this;
      me.$refs.mdlUploadFile.hide();
      me.$router.push("/printserver/view/" + me.jsonData.idReportMaster);
    },
    onClickFileIcon() {
      let me = this;
      me.$refs.mdlUploadFile.show();
      me.jsonDataReport = {
        name: "",
      };
      me.nomiFileOptions = [];
      me.jsonData.nomeFile = null;
      me.jsonData.stato = "ATTIVO";

      (me.jsonData.idReportMaster = me.reportMaster.reportMaster),
        (me.jsonData.codiceStruttura = me.reportMaster.struttura);
    },
    onUpdateReport(data) {
      let me = this;
      me.jsonDataReport = {};
      me.jsonDataReport = data;
      let nomeReportInserito = me.jsonDataReport.name.replace(".jasper", "");
      if (!me.isNewElement) {
        if (me.jsonData.reportName != nomeReportInserito) {
          me.messageErrorUpdateVersion = ` ${me.jsonData.reportName} e ${nomeReportInserito} non coincidono. Carica il file corretto!`;
          me.isOKFileUpload = false;
        } else {
          me.messageErrorUpdateVersion = "";
          me.isOKFileUpload = true;
        }
      } else {
        for (let report of me.nomiFileOptions) {
          let nomeFile = report.text;
          if (nomeFile === me.jsonDataReport.name) {
            me.messageErrorUpdateVersion = `Nome file già caricato, creare nuovo versioning !`;
            me.isNuovaVersioneI = true;
            me.isOKFileUpload = false;
          } else {
            me.messageErrorUpdateVersion = ``;
            me.isNuovaVersioneI = false;
            me.isOKFileUpload = true;
          }
        }
      }
    },
    onConfermaFile() {
      let me = this;
      if (me.jsonDataReport) {
        me.jsonData.reportName = me.jsonDataReport.name.replace(".jasper", "");
        me.nomiFileOptions.push({
          text: me.jsonDataReport.name,
          value: me.jsonDataReport.name,
        });
        me.jsonData.nomeFile = me.jsonDataReport.name;
        me.jsonData.fileBase64 = me.jsonDataReport.base64;
        me.$refs.mdlUploadFile.hide();
      }
    },
    onClickSelezionaFile() {
      this.$refs.mdlUploadFile.show();
    },
    onStampa() {
      let me = this;
      let printData = JSON.parse(me.jsonData.testData);
      let linkReport = process.env.VUE_APP_PATH_API + me.pathResourceStampa;
      axios
        .post(linkReport, {
          reportName: me.jsonData.reportName,
          data: printData,
        })
        .then((response) => {
          me.$refs.mdlStampaReferto.show();
          me.stampaReport =
            "data:application/pdf;base64," + response.data.base64;
        });
    },
    loadNomiFile() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkNomiFile;
      axios
        .get(link, { params: { struttura: me.strutturaCodice } })
        .then((response) => {
          if (response.data.data.list)
            response.data.data.list.forEach((element) => {
              me.nomiFileOptions.push({
                value: element.nomeFile,
                text: element.nomeFile,
              });
            });
        });
    },
  },
  watch: {
    "jsonData.testData": function (params) {
      let me = this;
      try {
        JSON.parse(params);
        me.jsonError = false;
      } catch (e) {
        me.jsonError = true;
      }
    },
  },
};
</script>
